import { atom } from 'jotai';

const ciMatomoActiveAtom = atom(false);

export { ciMatomoActiveAtom };